import { Model } from 'modules/core/lib/mobx-rest'

interface EmailBlock {
  value: string
  key_label: string
  key: string
  type: unknown
}

interface IMaterializedApprovalFlow {
  id: string
  status: string
  email_detail_blocks: EmailBlock[]
  approvers: any[]
  resource_id: string
  resource_type: string
  resource_type_complete: string
  author_id: string
  full_resource_type: string
  approval_flow_id: string
  owner_id: string
  override_approver_id: string
  rules_decision: string
  final_decision_at: string | null
  auto_approval_description: string | null
  can_approve?: boolean
  is_global_approver?: boolean
}

class MaterializedApprovalFlow extends Model<IMaterializedApprovalFlow> {
  static urlRoot() {
    return '/approvals/materialized_approval_flows'
  }

  get emailBlocks(): Array<EmailBlock | null> {
    return this.attributes.email_detail_blocks
  }

  get status(): string {
    return this.attributes.status
  }

  get isActive(): boolean {
    return this.attributes.status === 'running'
  }

  get resourceId(): string {
    return this.attributes.resource_id
  }

  get resourceTypeComplete(): string {
    return this.attributes.resource_type_complete
  }

  get resourceType(): string {
    return this.attributes.resource_type
  }

  get fullResourceType(): string {
    return this.attributes.full_resource_type
  }

  get authorId(): string {
    return this.attributes.author_id
  }

  get rulesDecision(): string {
    return this.attributes.rules_decision
  }

  get finalDecisionAt(): string | null {
    return this.attributes.final_decision_at
  }

  get autoApprovalDescription(): string | null {
    return this.attributes.auto_approval_description
  }

  get canApprove(): boolean {
    return this.attributes.can_approve ?? false
  }

  get isGlobalApprover(): boolean {
    return this.attributes.is_global_approver ?? false
  }
}

export default MaterializedApprovalFlow
